/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Canvas_Title_FallbackInputs */

const cs_builder_canvas_title_fallback = /** @type {(inputs: Builder_Canvas_Title_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadpis`)
};

const en_builder_canvas_title_fallback = /** @type {(inputs: Builder_Canvas_Title_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Builder_Canvas_Title_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_canvas_title_fallback = /** @type {((inputs?: Builder_Canvas_Title_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Canvas_Title_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_canvas_title_fallback(inputs)
	return cs_builder_canvas_title_fallback(inputs)
});